import { IMagentoStore } from '@wine-delivery/wd-shared-lib';
import { createContext } from 'react';
import { IAdminStore } from './AdminStore';

export const StoreContext = createContext<IMagentoStore>({} as IMagentoStore);
export const StoreProvider = StoreContext.Provider;

export const AdminStoreContext = createContext<IAdminStore>({} as IAdminStore);
export const AdminStoreProvider = AdminStoreContext.Provider;
